import reduceReducers from 'reduce-reducers';

//Siblings reducers
import notificationReducer from './notification-reducer';

export default reduceReducers(notificationReducer);
